const list = {
    //采购
    procurelist: [
    {
        showField: "商品名称",
        entityField: "bgmName",
        fieldType: "",
        fieldWeight: 150
    },
    {
        showField: "规格",
        entityField: "spec",
        fieldType: "",
        fieldWeight: 120
    },
    {
        showField: "生产厂商",
        entityField: "manufacturer",
        fieldType: "",
        fieldWeight: 150
    },
    {
        showField: "产地",
        entityField: "placeorigin",
        fieldType: "",
        fieldWeight: 100
    },
    {
        showField: "单位名称",
        entityField: "unitName",
        fieldType: "",
        fieldWeight: 150
    },
    {
        showField: "采购日期",
        entityField: "createTime",
        fieldType: "date",
        fieldWeight: 100
    },
    {
        showField: "含税价格",
        entityField: "psprice",
        fieldType: "",
        fieldWeight: 100
    },
    {
        showField: "数量",
        entityField: "num",
        fieldType: "",
        fieldWeight: 100
    },
    {
        showField: "含税金额",
        entityField: "psmoney",
        fieldType: "",
        fieldWeight: 100
    },

    {
        showField: "生产日期",
        entityField: "prodate",
        fieldType: "date",
        fieldWeight: 100
    },
    {
        showField: "有效期至",
        entityField: "expidate",
        fieldType: "date",
        fieldWeight: 100
    },
    {
        showField: "批号",
        entityField: "batchno",
        fieldType: "",
        fieldWeight: 100
    },

    {
        showField: "商品编号",
        entityField: "bgmCode",
        fieldType: "",
        fieldWeight: 150
    },
    {
        showField: "业务单号",
        entityField: "businessNum",
        fieldType: "",
        fieldWeight: 140
    },
    
    ],
    //销售
    saleProcurelist: [
        {
            showField: "商品名称",
            entityField: "bgmName",
            fieldType: "",
            fieldWeight: 150
        },
        {
            showField: "规格",
            entityField: "spec",
            fieldType: "",
            fieldWeight: 120
        },
        {
            showField: "生产厂商",
            entityField: "manufacturer",
            fieldType: "",
            fieldWeight: 150
        },
        {
            showField: "产地",
            entityField: "placeorigin",
            fieldType: "",
            fieldWeight: 100
        },
        {
            showField: "单位名称",
            entityField: "unitName",
            fieldType: "",
            fieldWeight: 150
        },
        {
            showField: "销售日期",
            entityField: "createTime",
            fieldType: "date",
            fieldWeight: 100
        },
        {
            showField: "含税价格",
            entityField: "psprice",
            fieldType: "",
            fieldWeight: 100
        },
        {
            showField: "数量",
            entityField: "num",
            fieldType: "",
            fieldWeight: 100
        },
        {
            showField: "含税金额",
            entityField: "psmoney",
            fieldType: "",
            fieldWeight: 100
        },
    
        {
            showField: "生产日期",
            entityField: "prodate",
            fieldType: "date",
            fieldWeight: 100
        },
        {
            showField: "有效期至",
            entityField: "expidate",
            fieldType: "date",
            fieldWeight: 100
        },
        {
            showField: "批号",
            entityField: "batchno",
            fieldType: "",
            fieldWeight: 100
        },
    
        {
            showField: "商品编号",
            entityField: "bgmCode",
            fieldType: "",
            fieldWeight: 150
        },
        {
            showField: "业务单号",
            entityField: "businessNum",
            fieldType: "",
            fieldWeight: 140
        },

        
    ],
    procurelistObj: [
        {
            label: "开始时间",
            prop: "start",
            fieldType: "date",
        },
        {
            label: "结束时间",
            prop: "end",
            fieldType: "date",
        }, {
            label: "购进单位",
            prop: "smName",
            fieldType: "search",
            searchId: "155784192757760",
            setField: "smName,smId"
        },
        {
            label: "通用名称",
            prop: "bgmName",
            fieldType: "search",
            searchId: "853533363572736",
            setField: "bgmName,bgmId"
        },
    ],
    salelistObj: [
        {
            label: "开始时间",
            prop: "start",
            fieldType: "date",
        },
        {
            label: "结束时间",
            prop: "end",
            fieldType: "date",
        }, {
            label: "销售单位",
            prop: "cmName",
            fieldType: "search",
            searchId: "157783642640384",
            setField: "cmName,cmId"
        },
        {
            label: "通用名称",
            prop: "bgmName",
            fieldType: "search",
            searchId: "853533363572736",
            setField: "bgmName,bgmId"
        },
    ]
}
export default list
